import { useState } from "react";
import ExpandableFeedbackPoint from "@container/feedback-expandable";
import { FeedbackItem } from "@type/interview";



interface FeedbackPointsListProps {
    points: FeedbackItem[];
}

export default function FeedbackPointsList({
    points,
}: FeedbackPointsListProps) {
    const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

    if (points.length === 0) {
        return (
            <div className="py-8 text-center text-gray-500">
                There's no feedback in this category yet.
            </div>
        );
    }

    const handleToggle = (index: number) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div className="divide-y divide-gray-100">
            {points.map((point, index) => (
                <ExpandableFeedbackPoint
                    key={index}
                    category={point.category}
                    text={point.title}
                    transcriptText={point.quote}
                    explanation={point.content}
                    isExpanded={expandedIndex === index}
                    onToggle={() => handleToggle(index)}
                />
            ))}
        </div>
    );
}
